import { api } from "@/lib/api";

// Official brand color per platform key. Used when style === "brand" | "filled".
// Keys must match what SHARE_PLATFORM_META (ShareBar) and PLATFORM_META (footer) use.
export const BRAND_COLORS = {
  twitter:  "#000000",
  facebook: "#1877F2",
  linkedin: "#0A66C2",
  reddit:   "#FF4500",
  email:    "#64748B",
  whatsapp: "#25D366",
  telegram: "#26A5E4",
  instagram:"#E4405F",
  youtube:  "#FF0000",
  bluesky:  "#0085FF",
  mastodon: "#6364FF",
  github:   "#181717",
};

export const ICON_STYLES = [
  { value: "monochrome", label: "Monochrome",  desc: "Subtle slate — minimal and understated." },
  { value: "brand",      label: "Brand colors", desc: "Each icon in its official brand color." },
  { value: "filled",     label: "Filled pills", desc: "Colored circle with a white icon on top." },
  { value: "outlined",   label: "Outlined pills", desc: "Thin border, fills in on hover." },
];
export const ICON_SIZES = [
  { value: "sm", label: "Small" },
  { value: "md", label: "Medium" },
  { value: "lg", label: "Large" },
];

// Sizing tokens per size key. cell = the tap target (round wrapper), icon = svg size.
export const SIZE_TOKENS = {
  sm: { cell: "w-7 h-7", icon: "w-3.5 h-3.5" },
  md: { cell: "w-8 h-8", icon: "w-4 h-4" },
  lg: { cell: "w-10 h-10", icon: "w-5 h-5" },
};

let _cache = null;
let _promise = null;
export async function loadIconStyleSettings() {
  if (_cache) return _cache;
  if (!_promise) {
    _promise = api.get("/site-settings/icon-style")
      .then(r => { _cache = r.data; return r.data; })
      .catch(() => ({ style: "monochrome", size: "md" }));
  }
  return _promise;
}
export function invalidateIconStyleCache() { _cache = null; _promise = null; }

/**
 * Build the wrapper className + inline style for a single social/share icon.
 * Returns { className, style } that the caller spreads onto the <a> or <button>.
 */
export function iconWrapperProps({ platformKey, styleName = "monochrome", sizeName = "md", hoverColor = null }) {
  const tokens = SIZE_TOKENS[sizeName] || SIZE_TOKENS.md;
  const brand = BRAND_COLORS[platformKey] || "#64748B";
  const base = `${tokens.cell} grid place-items-center rounded-full transition-colors`;

  if (styleName === "brand") {
    return {
      className: `${base} hover:bg-slate-100`,
      style: { color: brand },
      iconSizeClass: tokens.icon,
    };
  }
  if (styleName === "filled") {
    return {
      className: `${base} text-white`,
      style: { backgroundColor: brand },
      iconSizeClass: tokens.icon,
      hoverStyle: { opacity: 0.9 },
    };
  }
  if (styleName === "outlined") {
    return {
      className: `${base} border border-slate-300 dark:border-slate-600 text-slate-600 dark:text-slate-300 hover:text-white`,
      style: { borderColor: brand + "80" }, // 50% alpha border
      hoverStyle: { backgroundColor: brand, borderColor: brand },
      iconSizeClass: tokens.icon,
    };
  }
  // monochrome (default)
  return {
    className: `${base} text-slate-500 hover:text-slate-900 dark:text-slate-400 dark:hover:text-slate-100 hover:bg-slate-100 dark:hover:bg-slate-700`,
    style: {},
    iconSizeClass: tokens.icon,
  };
}
